import axios from 'axios';
import { getUserToken } from '../../utils/localStoarege';
import { hudDoctoViewPatchUrl, hudPackageApiCRUDUrl } from '../../constants/apis/hud_apis';
import { hudDoctoViewGetUrl, hudGetUserPhotosUrl } from '../../constants/apis/doctor_apis';

export const getHudDoctorView = async () => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudDoctoViewGetUrl, config);
    return response;
};

export const getPatientPhotos = async (patientId) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudGetUserPhotosUrl + patientId + "/history/photos/?page_size=50", config);
    return response;
};

export const addHudPatientDoses = async (packageId, data) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(hudPackageApiCRUDUrl + packageId + "/add-dose/", data, config);
    return response;
};

export const patchHudPatientDoctorView = async (data) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(hudDoctoViewPatchUrl, data, config);
    return response;
};
